import { Fragment } from 'react';
import { nameSlashBreaks } from '../../libs/nameBreaks';

/** A display name with a `<wbr>` after each slash that joins two names ("Stellar/<wbr>Blade 1"),
 * so a long team name wraps there instead of mid-word. "a/l", "a/p" stay whole. Text is unchanged. */
export function NameText({ name }: { name: string }) {
  const parts = nameSlashBreaks(name);
  if (parts.length < 2) return <>{name}</>;
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <wbr />}
          {part}
        </Fragment>
      ))}
    </>
  );
}
